export default __webpack_public_path__ + "static/media/ame-title.42e84f91.svg";